import { EServiceId } from '../../../../../../../../redux/reducers';

export const DATE_PATTERN = 'dd.MM';

export const PACKAGE_NAMES = {
  [EServiceId.top]: {
    single: 'Топ',
    plural: 'Топа',
    pluralSecondForm: 'Топов',
  },
  [EServiceId.premium]: {
    single: 'Премиум',
    plural: 'Премиума',
    pluralSecondForm: 'Премиумов',
  },
  [EServiceId.paid]: {
    single: 'публикация',
    plural: 'публикации',
    pluralSecondForm: 'публикаций',
  },
  [EServiceId.free]: {
    single: 'публикация',
    plural: 'публикации',
    pluralSecondForm: 'публикаций',
  },
};
